import React, { useState } from "react";
import { IconButton} from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

const CustomImageSlider = ({ images, autoSlideInterval = 3000 }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentImageIndex((prevIndex) =>
  //       prevIndex === images.length - 1 ? 0 : prevIndex + 1
  //     );
  //   }, autoSlideInterval);

  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, [images, autoSlideInterval]);

  const handleDotClick = (index) => {
    setCurrentImageIndex(index);
  };

  const arrowHandler = (type) =>{
    if(type === 1){
      if(currentImageIndex === images.length - 1){
        setCurrentImageIndex(0)
      }else setCurrentImageIndex(prev => prev + 1)
    }
    if(type === 0){
      if(currentImageIndex !== 0){
        setCurrentImageIndex(prev => prev - 1)
      }
    }
  }

  return (
    <div style={{ width: '100%' }}>
      <div style={{ fontSize: 22, fontWeight: 600, color: "#FFF", marginBottom: 10 }}>{images[currentImageIndex].text}</div>
      <div className="slider">
        {images.map((image, index) => (
          <>
            {image.type === 'image' ?
              <img
                key={index}
                src={image.image}
                alt={`slideImage_${index + 1}`}
                className={index === currentImageIndex ? "slide active" : "slide"}
                style={{ width: '100%', height: '100%' }}
              />
              : <YoutubeEmbed embedId="loJgTJEKv2U" />
            }
          </>
        ))}
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 10 }}>
        <div>
          <IconButton size="small" onClick={() =>  arrowHandler(0)} disabled={currentImageIndex === 0}><ArrowBackIosIcon style={{ color: "#FFF" }} /></IconButton>
        </div>
        <div className="dots">
          {images.map((_, index) => (
            <span
              key={index}
              className={index === currentImageIndex ? "dot active" : "dot"}
              onClick={() => handleDotClick(index)}
            />
          ))}
        </div>
        <div>
          <IconButton size="small" onClick={() => arrowHandler(1)}><ArrowForwardIosIcon style={{ color: "#FFF" }} /></IconButton>
        </div>
      </div>
    </div>
  );
};

const YoutubeEmbed = ({ embedId }) => (
  <div className="video-responsive">
      <iframe
          src={`https://www.youtube.com/embed/${embedId}`}
          frameBorder="0"
          allow=""
          allowFullScreen
          title="Embedded youtube"
      />
  </div>
);

export default CustomImageSlider;